import moment from 'moment';
moment.locale('th');

export const getCurrentDateTime = (format = 'MMMM Do YYYY, h:mm:ss a') => {
  return moment().format(format);
};

export function formatDateTime(value) {
  return moment(String(value)).add(543, 'year').format('DD MMM YY HH:mm:ss');
}

export function formatDate(value) {
  return moment(String(value)).add(543, 'year').format('DD MMM YY')
}

export function formatTime(value) {
  return moment(String(value), 'HH:mm:ss').format('HH:mm น.');
}
